import { institutionsRepository } from '@/forms/api/repository-factory';
import store from '@/store';
import { SET_INSTITUTIONS } from '@/lib/constants/mutations';

export default {
  async searchInstitutions(search) {
    if (store.state.institutions.length === 0) {
      const institutionsResponse = await institutionsRepository.getInstitutions();

      if (institutionsResponse) {
        const institutionsList = institutionsResponse.data.Institutions.Institution;
        store.commit(
          SET_INSTITUTIONS,
          {
            institutions: institutionsList,
          },
        );
      }
    }

    let filtered;

    if (search && search !== '') {
      filtered = store.state.institutions
        .filter(institution => institution.name.toUpperCase().includes(search.toUpperCase()));
    } else {
      filtered = store.state.institutions;
    }
    return { data: filtered };
  },
};
